import stackBackgroundPlaceholder from 'assets/stack-bg-placeholder.jpg';
import stackBackground from 'assets/video/stack-bg.mp4';
import { Footer } from 'components/Footer';
import { HotkeyNav } from 'components/HotkeyNav';
import { Meta } from 'components/Meta';
import { usePageHotkeys, useHashNavigation } from 'hooks';
import {
  ProjectBackground,
  ProjectContainer,
  ProjectHeader,
  ProjectSection,
  ProjectSectionContent,
} from 'layouts/Project';
import { AnimatePresence, motion } from 'framer-motion';
import { Fragment, useMemo } from 'react';
import {
  HardwareContent,
  SoftwareContent,
  QuotesContent,
} from './content';
import { categories } from './data';
import styles from './Stack.module.css';

const contentComponents = {
  hardware: HardwareContent,
  software: SoftwareContent,
  quotes: QuotesContent,
};

export const Stack = () => {
  const validIds = useMemo(() => categories.map(c => c.id), []);
  const [activeCategory, setActiveCategory] = useHashNavigation(validIds, 'hardware', '/stack');

  // Handle page-level hotkeys for category navigation
  usePageHotkeys(categories, setActiveCategory);

  const activeCategoryData = categories.find(c => c.id === activeCategory);
  const ContentComponent = contentComponents[activeCategory];

  return (
    <Fragment>
      <Meta
        title={activeCategoryData?.title === 'Stack' ? 'Stack' : `${activeCategoryData?.title} | Stack`}
        description={activeCategoryData?.description}
      />
      <ProjectContainer className={styles.stack}>
        <ProjectBackground
          src={{ src: stackBackground }}
          placeholder={stackBackgroundPlaceholder}
          opacity={0.7}
        />
        <AnimatePresence mode="wait">
          <motion.div
            key={`header-${activeCategory}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
          >
            <ProjectHeader
              title={activeCategoryData?.title}
              description={activeCategoryData?.pageDescription}
              className={styles.centeredHeader}
            />
          </motion.div>
        </AnimatePresence>
        <ProjectSection padding="none" className={`${styles.section} ${styles.stackNavSection}`}>
          <ProjectSectionContent>
            <HotkeyNav
              items={categories}
              activeId={activeCategory}
              onSelect={setActiveCategory}
            />
          </ProjectSectionContent>
        </ProjectSection>
        <AnimatePresence mode="wait">
          <motion.div
            key={`content-${activeCategory}`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            <ContentComponent />
          </motion.div>
        </AnimatePresence>
      </ProjectContainer>
      <Footer />
    </Fragment>
  );
};
